import React, { useState, useRef } from 'react';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';
import IconButton from '@material-ui/core/IconButton';
import Popover from '@material-ui/core/Popover';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { Link } from 'react-router-dom';
import MenuIcon from '@material-ui/icons/Menu';
import { signInPath } from '../sign-in-path';
import { useCampfireTheme } from '../../../theme/useCampfireTheme';
import { useCampfireQuery } from '../../network/useCampfireQuery';
import { GET_ORG_NAME } from '../../../screens/public-screens/login/sign-in-model.gql';
import { GetOrgName } from '../../../screens/public-screens/login/__generated__/GetOrgName';

interface PublicAppBarProps {
  notRequiredSignin?: boolean;
}
const MobilePublicAppBar = (props: PublicAppBarProps) => {
  const { theme } = useCampfireTheme();
  const { data } = useCampfireQuery<GetOrgName, {}>(GET_ORG_NAME, { options: { fetchPolicy: 'cache-first' } });
  const applicationsClosed = data?.vm.applicationsClosed ?? false;

  const [showMenu, setOpenMenu] = useState(false);
  const openMenu = () => setOpenMenu(true);
  const closeMenu = () => setOpenMenu(false);
  const ref = useRef<HTMLButtonElement | null>(null);

  return (
    <AppBar
      style={{
        background: 'white',
        color: '#242424',
        boxShadow: 'none',
        // height: theme.appShell.menu.height,
      }}
    >
      <Box paddingY={1} paddingX={1}>
        <Grid container justify='flex-end'>
          <Grid item>
            <IconButton style={{ color: '#242424' }} ref={ref} onClick={openMenu}>
              <MenuIcon />
            </IconButton>
            {!props.notRequiredSignin && (
              <Popover
                open={showMenu}
                onClose={closeMenu}
                anchorEl={ref ? ref.current : undefined}
                anchorReference={'anchorEl'}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
              >
                <Paper>
                  <Box minWidth={128}>
                    <List disablePadding>
                      <Link
                        to={signInPath}
                        style={{
                          color: 'inherit',
                          textDecoration: 'none',
                          textDecorationColor: 'none',
                        }}
                      >
                        <ListItem button onClick={closeMenu}>
                          <ListItemText primary='Sign In' style={{ textAlign: 'end' }} />
                        </ListItem>
                      </Link>

                      {!applicationsClosed && (
                        <Link
                          to='/apply'
                          style={{
                            textDecoration: 'none',
                            textDecorationColor: 'none',
                            color: theme.palette.primary.main,
                          }}
                        >
                          <ListItem button onClick={closeMenu}>
                            <ListItemText primary='Make an account' style={{ textAlign: 'end' }} />
                          </ListItem>
                        </Link>
                      )}
                    </List>
                  </Box>
                </Paper>
              </Popover>
            )}
          </Grid>
        </Grid>
      </Box>
    </AppBar>
  );
};

export default MobilePublicAppBar;
